import React from "react";
import AdminHeader from "../../_components/AdminHeader/AdminHeader";
import AdminSidebar from "../../_components/AdminSidebar/AdminSidebar";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import NoDataText from "../../_components/NoDataText/NoDataText";
import ConfirmationAlert from "../../_components/ConfirmationAlert/ConfirmationAlert";
import modelManagementService from "../../_services/modelManagement.service";
import authenticationService from "../../_services/authentication.service";
import Autocomplete from "../../_components/Autocomplete/Autocomplete";
import accessoryfinderService from "../../_services/accessoryfinder.service";
import "./ModelManagement.css";
import UpdateModelManagement from "../../_components/UpdateModelManagement";

class ModelManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true,
      isModelOpen: false,
      brandData: [],
      searchText: "",
      id: 0,
      showUpdateModelManagement: false,
      updateModelManagement: {},
      modelManagement: {
        brandName: "",
        vacuumModelName: "",
        vacuumModelSeriesMaster: [
          {
            VacuumModelSeriesName: "",
            enabled: true,
            createdBy: authenticationService?.currentUserValue?.id,
          },
        ],
        createdBy: authenticationService?.currentUserValue?.id,
      },
      result: {},
      resultForSearch: {},
      errors: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleResetForm = this.handleResetForm.bind(this);
    this.autoCompleteHandleChange = this.autoCompleteHandleChange.bind(this);
    this.searchOnChange = this.searchOnChange.bind(this);
  }

  handleChange(event) {
    const { name, value } = event.target;
    const { modelManagement, errors } = this.state;

    this.setState({
      modelManagement: {
        ...modelManagement,
        [name]: value,
      },
      errors: {
        ...errors,
        [name]: "",
      },
    });
  }
  autoCompleteHandleChange(name, value) {
    if (value !== undefined) {
      const { modelManagement, errors } = this.state;
      this.setState({
        modelManagement: {
          ...modelManagement,
          [name]: value,
        },
        errors: {
          ...errors,
          [name]: "",
        },
      });
    }
  }

  handleChangeVacuumModelSeries = (idx) => (e) => {
    const { name, value } = e.target;
    const rows = [...this.state?.modelManagement?.vacuumModelSeriesMaster];
    rows[idx] = {
      [name]: value,
      enabled: true,
      createdBy: authenticationService?.currentUserValue?.id,
    };
    this.setState({
      modelManagement: {
        ...this.state?.modelManagement,
        vacuumModelSeriesMaster: rows,
      },
    });
  };
  handleAddRow = () => {
    const item = {
      VacuumModelSeriesName: "",
      enabled: true,
      createdBy: authenticationService?.currentUserValue?.id,
    };
    let vacuumModelSeriesMaster =
      this.state?.modelManagement?.vacuumModelSeriesMaster;
    vacuumModelSeriesMaster.push(item);
    this.setState({
      modelManagement: {
        ...this.state?.modelManagement,
        vacuumModelSeriesMaster: vacuumModelSeriesMaster,
      },
    });
  };

  handleRemoveSpecificRow = (idx) => () => {
    const rows = [...this.state?.modelManagement?.vacuumModelSeriesMaster];
    rows.splice(idx, 1);
    this.setState({
      modelManagement: {
        ...this.state?.modelManagement,
        vacuumModelSeriesMaster: rows,
      },
    });
  };

  handleClick = (e) => {
    this.setState({ isOpen: !this.state?.isOpen });
  };
  handleModelEdit(cell, row, rowIndex) {
    const list = this.state?.result?.data?.filter(
      (u) => u?.vacuumModelId === cell,
    );

    console.log("list", list);

    if (list.length > 0) {
      let modelData = list[0];
      modelData.createdBy = authenticationService?.currentUserValue?.id;
      modelData.lastUpdatedBy = authenticationService?.currentUserValue?.id;
      this.setState({
        showUpdateModelManagement: true,
        updateModelManagement: list[0],
      });
    }
  }
  updateClose = (isUpdated) => {
    if (isUpdated) {
      this.getData();
    }
    let updateModelManagement = {};
    this.setState({
      showUpdateModelManagement: false,
      updateModelManagement: updateModelManagement,
    });
  };
  handleModelDelete(cell, row, rowIndex) {
    let alertMember = {
      show: true,
      isAnimate: false,
      ariaLabelledby: "",
      title: "Confirmation",
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: this.handleYes,
          cssclass: "btn btn-primary btn-sm ts-buttom",
        },
        {
          label: "No",
          onClick: this.handleNo,
          cssclass: "btn btn-danger btn-sm ml-2 ts-buttom",
        },
      ],
    };
    this.setState({ isModelOpen: true, alertMember: alertMember, id: cell });
  }
  handleYes = (e) => {
    e.preventDefault();
    const { id } = this.state;
    const model = {
      VacuumModelId: id,
    };
    let formData = JSON.stringify(model);
    modelManagementService
      .delete(formData)
      .then((data) => this.responseShow(data))
      .catch((error) => console.log("Error :" + error));
  };

  handleNo = (e) => {
    this.setState({ isModelOpen: false, alertMember: {} });
  };

  handleSubmit = (e) => {
    if (this.validateForm()) {
      let { modelManagement } = this.state;
      let seriesName = modelManagement?.vacuumModelSeriesMaster?.filter(
        (p) => p?.VacuumModelSeriesName !== "",
      );
      modelManagement.vacuumModelSeriesMaster = seriesName;

      let formData = JSON.stringify(modelManagement);
      modelManagementService
        .addModelnSeries(formData)
        .then((data) => this.responseShow(data))
        .catch((error) => console.log("Error :" + error));
    }
  };
  responseShow(obj) {
    if (obj.isSuccess) {
      this.resetForm();
      this.getData();
    }

    let alertMember = {
      show: true,
      isAnimate: false,
      ariaLabelledby: "",
      title: "Confirmation",
      message: obj.message,
      buttons: [
        {
          label: "Close",
          onClick: this.handleNo,
          cssclass: "btn btn-primary btn-sm ts-buttom",
        },
      ],
    };
    this.setState({ isModelOpen: true, alertMember: alertMember });
  }
  handleResetForm = (e) => {
    this.resetForm();
  };
  componentDidMount() {
    this.getData();
    this.getBrand();
  }
  getData() {
    modelManagementService
      .getModelnSeriesList()
      .then((data) => this.setState({ result: data, resultForSearch: data }))
      .catch((error) => console.log("Error :" + error));
  }

  GetActionFormat = (cell, row, rowIndex) => {
    return (
      <div>
        <button
          data-tip="hello world"
          type="button"
          className="btn btn-outline-primary btn-sm ts-buttom"
          size="sm"
          onClick={() => this.handleModelEdit(cell, row, rowIndex)}
        >
          <i className="fa fa-edit"></i>
        </button>
        <button
          type="button"
          className="btn btn-outline-danger btn-sm ml-2 ts-buttom"
          size="sm"
          onClick={() => this.handleModelDelete(cell, row, rowIndex)}
        >
          <i className="fa fa-trash"></i>
        </button>
      </div>
    );
  };

  enabledFormatter = (cell, row) => {
    return cell ? <span>Yes</span> : <span>No</span>;
  };

  getvacuumModelSerielist = (cell, row) => {
    let text = "";
    if (cell && cell.length > 0) {
      cell.map((data) => {
        return (text = text + data?.vacuumModelSeriesName + " ,");
      });
      text = text.slice(0, -1);
    }
    return <span>{text}</span>;
  };

  validateForm() {
    let { modelManagement } = this.state;
    let errors = {};
    let isFormValid = true;

    if (!modelManagement?.brandName) {
      isFormValid = false;
      errors["brandName"] = "Enter Brand Name";
    }
    if (!modelManagement?.vacuumModelName) {
      isFormValid = false;
      errors["vacuumModelName"] = "Enter Vacuum Model Name";
    }

    this.setState({
      errors: errors,
    });
    return isFormValid;
  }
  resetForm() {
    this.setState({
      modelManagement: {
        brandName: "",
        vacuumModelName: "",
        vacuumModelSeriesMaster: [
          {
            VacuumModelSeriesName: "",
            enabled: true,
            createdBy: authenticationService?.currentUserValue?.id,
          },
        ],
        createdBy: authenticationService?.currentUserValue?.id,
      },
    });
  }

  getBrand = () => {
    accessoryfinderService
      .getAllBrands()
      .then((data) => {
        if (data?.isSuccess) {
          this.setState({ brandData: data?.data });
        }
      })
      .catch((error) => console.log("Error :" + error));
  };
  handleNo = (e) => {
    this.setState({ isModelOpen: false, alertMember: {} });
  };
  searchOnChange = (e) => {
    const { resultForSearch } = this.state;
    const { value } = e.target;

    if (resultForSearch.data && resultForSearch.data.length > 0) {
      const filteredData = resultForSearch.data.filter(
        (model) =>
          model.vacuumModelName.toLowerCase().indexOf(value.toLowerCase()) > -1,
      );
      // const filteredDatabySeries = resultForSearch.data.filter(
      //   model =>
      //   {
      //     if(model.vacuumModelSeriesMaster && model.vacuumModelSeriesMaster.length > 0)
      //     {
      //         return(
      //           model.vacuumModelSeriesMaster.filter(
      //              p => (p.vacuumModelSeriesName != null && p.vacuumModelSeriesName.toLowerCase().indexOf(value.toLowerCase()) > -1 )
      //           )
      //         )
      //     }
      //   }
      // );
      this.setState({
        result: { data: [...filteredData] },
        searchText: value,
      });
    }
  };
  render() {
    const options = {
      sizePerPage: 5,
      hideSizePerPage: true,
      hidePageListOnlyOnePage: true,
    };

    const columns = [
      {
        dataField: "vacuumModelName",
        text: "Vacuum Model Name",
        headerStyle: (colum, colIndex) => {
          return { width: "210px", textAlign: "left" };
        },
      },
      {
        dataField: "vacuumModelSeriesMaster",
        text: "Model Series",
        formatter: this.getvacuumModelSerielist,
      },
      {
        dataField: "enabled",
        text: "Active",
        formatter: this.enabledFormatter,
        headerStyle: (colum, colIndex) => {
          return { width: "70px", textAlign: "center" };
        },
      },
      {
        text: "#Action",
        dataField: "vacuumModelId",
        formatter: this.GetActionFormat,
        headerStyle: (colum, colIndex) => {
          return { width: "100px", textAlign: "center" };
        },
      },
    ];
    const showClass = `page-wrapper chiller-theme ${
      this.state?.isOpen ? "toggled" : ""
    }`;
    const {
      result,
      isModelOpen,
      alertMember,
      modelManagement,
      searchText,
      showUpdateModelManagement,
    } = this.state;
    return (
      <React.Fragment>
        {isModelOpen ? <ConfirmationAlert {...alertMember} /> : null}
        <div className={showClass}>
          <AdminHeader />
          <AdminSidebar handleClick={this.handleClick} />
          <main className="page-content">
            <div className="container-fluid">
              <h4 className="text-left">Model Management</h4>
              <hr className="hr" />
              <div className="row">
                <div className="col-sm-12">
                  <div className="box box-primary">
                    <form name="form">
                      <div className="box-body">
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="brandName">Brand Name</label>
                              <Autocomplete
                                id="brandName"
                                name="brandName"
                                value={modelManagement?.brandName}
                                maxLength="50"
                                className={
                                  "form-control" +
                                  (this.state?.errors?.brandName
                                    ? " invalid"
                                    : "")
                                }
                                placeholder="Brand Name"
                                onClientChange={this.autoCompleteHandleChange}
                                suggestions={this.state?.brandData}
                              />
                              {this.state?.errors?.brandName && (
                                <small className="help-block">
                                  {this.state?.errors?.brandName}
                                </small>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-6">&nbsp;</div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="vacuumModelName">
                                Vacuum Model Name
                              </label>
                              <input
                                id="vacuumModelName"
                                name="vacuumModelName"
                                value={modelManagement?.vacuumModelName}
                                onChange={this.handleChange}
                                maxLength="50"
                                type="text"
                                className={
                                  "form-control" +
                                  (this.state?.errors?.vacuumModelName
                                    ? " invalid"
                                    : "")
                                }
                                placeholder="Vacuum Model Name"
                              />
                              {this.state?.errors?.vacuumModelName && (
                                <small className="help-block">
                                  {this.state?.errors?.vacuumModelName}
                                </small>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-6">&nbsp;</div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="tbl_vacuumModelSeries">
                                Vacuum Model Series
                              </label>
                              <table
                                className="table table-bordered"
                                id="tbl_vacuumModelSeries"
                              >
                                <tbody>
                                  {modelManagement?.vacuumModelSeriesMaster?.map(
                                    (item, idx) => (
                                      <tr id="addr0" key={idx}>
                                        <td>{idx + 1}</td>
                                        <td>
                                          <input
                                            type="text"
                                            name="VacuumModelSeriesName"
                                            value={item.VacuumModelSeriesName}
                                            onChange={this.handleChangeVacuumModelSeries(
                                              idx,
                                            )}
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          {idx > 0 ? (
                                            <button
                                              type="button"
                                              className="btn btn-outline-danger btn-sm"
                                              onClick={this.handleRemoveSpecificRow(
                                                idx,
                                              )}
                                            >
                                              Remove
                                            </button>
                                          ) : null}
                                        </td>
                                      </tr>
                                    ),
                                  )}
                                </tbody>
                              </table>
                              <button
                                type="button"
                                onClick={this.handleAddRow}
                                className="btn btn-outline-primary btn-sm"
                              >
                                Add Row
                              </button>
                            </div>
                          </div>
                          <div className="col-sm-6">&nbsp;</div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <hr />
                          </div>
                          <div className="col-sm-6">&nbsp;</div>
                        </div>
                        <div className="row">
                          <div className="col-md-12 text-left">
                            <button
                              type="button"
                              onClick={this.handleSubmit}
                              className="btn btn-primary"
                            >
                              SAVE
                            </button>
                            &nbsp;
                            <button
                              type="button"
                              onClick={this.handleResetForm}
                              className="btn btn-primary"
                            >
                              RESET
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col-sm-6">
                  <h5>Model List</h5>
                </div>
                <div className="col-sm-6">
                  <input
                    name="searchBox"
                    value={searchText}
                    onChange={(e) => this.searchOnChange(e)}
                    maxLength="50"
                    type="text"
                    className="form-control"
                    placeholder="search"
                  />
                </div>
              </div>
              <div className="row margin-top">
                <div className="col-sm-12">
                  <div className="box">
                    {result.data && result.data.length > 0 ? (
                      <BootstrapTable
                        keyField={"id"}
                        data={result.data}
                        columns={columns}
                        pagination={paginationFactory(options)}
                      />
                    ) : (
                      <NoDataText columns={columns} message="No Data Found" />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
        {showUpdateModelManagement ? (
          <UpdateModelManagement
            updateModelManagement={this.state?.updateModelManagement}
            updateClose={this.updateClose}
            brandData={this.state?.brandData}
          />
        ) : null}
      </React.Fragment>
    );
  }
}
export default ModelManagement;
